import React from 'react'
import SyntaxHighlighter from 'react-syntax-highlighter';
import { sunburst } from 'react-syntax-highlighter/dist/esm/styles/hljs';
function CodeHighlight({ code, title, language = 'javascript'}) {
    return (
        <div className='relative overflow-hidden rounded-lg w-full'>
            <div className='flex items-center px-3 gap-4 py-1 absolute top-0 bg-[rgb(45,63,60)] w-full'>
                <div className='flex items-center gap-2'>
                    <div className='h-3 w-3 rounded-full bg-red-500'></div>
                    <div className='h-3 w-3 rounded-full bg-green-500'></div>
                </div>
                <span className=' text-neutral-200'>{title}</span>
            </div>
            <SyntaxHighlighter customStyle={{
                padding: '20px',
                backgroundColor: 'rgb(31,45,43)'
            }} language={language} style={sunburst}>
                {code}
            </SyntaxHighlighter>
        </div>
    )
}

export default CodeHighlight
